<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!---------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td>
          <td-value
            copyToClipboard
            class="font-vazir-ui"
            [value]="item?.id"
          ></td-value>
        </td>

        <!-- title -->
        <td>
          <td-value
            copyToClipboard
            class="font-vazir-ui"
            [value]="item?.title"
          ></td-value>
        </td>

        <!-- organizationName -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            copyToClipboard
            class="font-vazir-ui"
            [value]="item?.organizationName"
          ></td-value>
        </td>

        <!--  isActive -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value type="boolean" [value]="item?.isActive"></td-value>
        </td>

        <!-- expirationType -->
        <td>
          <span [expirationType]="item?.expirationType">
            {{ item?.expirationType | enumToText : ExpirationType }}
          </span>
        </td>

        <!-- expiration -->
        <td>
          <td-value copyToClipboard [value]="item?.expiration"></td-value>
        </td>

        <!-- depositPrice -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.depositPrice"
            type="number"
          ></td-value>
        </td>

        <!-- originalPrice -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.originalPrice"
            type="number"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="date" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit button -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item.id)"></div>
          
            <!-- delete button -->
            <div app-menu-btn icon="delete" (click)="onDelete(item.id, item.title)"></div>

          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-package-sales-form
    page-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-package-sales-form>
</ng-container>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------- help ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
